module.exports = __webpack_public_path__ + "media/images/responsive/page_common/logo/logo_eight_black-053d013abfbc0200fd6a472b22b86674.svg";